import React from 'react';
import { useRestaurantNav } from '../../hooks/useRestaurantNav';

const NotFound: React.FC = () => {
  const { navigate } = useRestaurantNav();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-[#000000] flex">
      {/* Left side - 404 Image */}
      <div className="w-1/2 flex items-center justify-center p-12">
        <img 
          src="/assets/images/404.png" 
          alt="404 Error"
          className="max-w-full h-auto object-contain"
        />
      </div>

      {/* Right side - Text Content */}
      <div className="w-1/2 flex items-center justify-center p-12">
        <div className="text-left">
          <p className="text-white text-4xl font-light mb-6 leading-tight">
           You've wondered somewhere you shouldn't be.
          </p>
          <p className="text-white text-2xl font-light">
            We have another way{' '}
            <button
              onClick={handleGoHome}
              className="text-[#ee4423] underline decoration-2 underline-offset-4 cursor-pointer transition-colors cursor-pointer bg-transparent border-none p-0 font-light inline"
            >
              home.
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
